import { GET_ACCESS_GROUPS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface ConfigurationResponse {
    groups: {
        id: string;
        name: string;
        doctors: string[];
    }[];
}

export default (): Promise<ConfigurationResponse> => {
    return fetchWithRefresh(GET_ACCESS_GROUPS).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw Error('failed GET_ACCESS_GROUPS');
        }
    });
};
